import ProTable from './ProTable';
import EditableProTable from './EditableProTable';
export { EditableProTable };
export default ProTable;
